export default __webpack_public_path__ + "static/media/reddit.2d1d81cd.webp";